import React, {Component} from 'react'
import axios from 'axios'
import * as _ from 'lodash-joins'

import CS from '../../../commons/services/Common'
import MS from '../../../commons/services/Moment'
import AS from '../../Login/Service/Authentication'
import PS from '../../PlantList/MonitoringApiService'
import { invert } from 'lodash';


class Combiner extends Component {

    constructor(props) {
        super(props)
        this.state = {
            batchType: "row",
            plantId: props.match.params.plantId,
        }
    }


    componentDidMount = () => {
    }

    

    render() {
        const {
            
        } = this.state;
        
        return (
            <>
                <div className="container">
                    <div className="table-wrapper">
                        <table className="h-table">
                            <colgroup>
                                <col style={{width: "8%"}}/>
                                <col style={{width: "25%"}}/>
                                <col />
                                <col style={{width: "8%"}}/>
                                <col style={{width: "10%"}}/>
                                <col style={{width: "13%"}}/>
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>번호</th>
                                    <th>발전소명</th>
                                    <th>주소</th>
                                    <th>사업자명</th>
                                    <th>보증 완료 기간</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {/*
                                    items.length > 0
                                    ?
                                        items.map((row, index) => (
                                            <tr key={row.id}>
                                                <td>
                                                    <label className="num">
                                                        { this.state.totalCount - ((this.state.currentPage-1)*this.state.perPageSize + index) }
                                                    </label>
                                                </td>
                                                <td>{row.name}</td>
                                                <td className="left">{row.address}</td>
                                                <td>{row.ownerName}</td>
                                                <td>{row.serviceWarrantyDt}</td>
                                                <td>
                                                    <Link to={"/plant-list/detail/" + row.id} className="btn sm mr-5">세부정보</Link>
                                                    <Link to={"/plant-list/update/" + row.id} className="circle-btn">
                                                        <i className="material-icons">edit</i>
                                                    </Link>
                                                </td>
                                            </tr>
                                        ))
                                        :
                                        <tr>
                                            <td colSpan="6">등록된 발전소가 존재하지 않습니다.</td>
                                        </tr>
                                        */}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
}

export default Combiner
